(function () {
  function deepQuery(selector, root = document) {
    if (root.querySelector) {
      const found = root.querySelector(selector);
      if (found) return found;
    }

    const nodes = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (const node of nodes) {
      if (node.shadowRoot) {
        const found = deepQuery(selector, node.shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  function waitForDeepQuery(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const timer = setInterval(() => {
        const el = deepQuery(selector);
        if (el) {
          clearInterval(timer);
          resolve(el);
        }
        if (Date.now() - start > timeout) {
          clearInterval(timer);
          reject();
        }
      }, 100);
    });
  }

  waitForDeepQuery('button.hover-effect-button').then(btn => {

    const form = btn.closest('form');
    if (!form) {
      console.warn('[chat-tracker] form not found');
      return;
    }

    form.addEventListener(
      'submit',
      () => {
        const root = deepQuery('#chat-ui');

        const firstName = deepQuery(
          'input[aria-label="First Name"]',
          root
        )?.value?.trim();

        const lastName = deepQuery(
          'input[aria-label="Last Name"]',
          root
        )?.value?.trim();

        const email = deepQuery(
          'input[aria-label="Email Address"]',
          root
        )?.value?.trim();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'chat_form_send'
        });

      },
      true // 🔥 capture phase 
    );
  });
})();
